import { AllPermissions as SharedAllPermissions, Permission as SharedPermission } from 'shared-lib'

export const Permission = SharedPermission
// /**
//  * All recognised permissions should be noted in this type
//  */
export type AllPermissions = SharedAllPermissions
